import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'

const mapStateToProps = (state: ReduxState) => {
  return {
    error: selectors.errorSelector(state),
    reportData: selectors.salesFunnelAnalyzeReportSelector(state),
    isLoading: selectors.isLoadingSelector(state, 'isSalesFunnelAnalyzeLoading')
  }
}

const mapDispatchToProps = {
  fetchSalesFunnelAnalyzeReport: actions.fetchSalesFunnelAnalyzeReport
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
